import React, { useState } from 'react';

export default function AccordionBox({ items = [], styleClass = '' }) {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggle = (i) => {
    setActiveIndex(activeIndex === i ? -1 : i);
  };

  return (
    <ul className={`accordion-box ${styleClass}`}>
      {items.map((item, i) => (
        <li key={i} className={`accordion block${activeIndex === i ? ' active-block' : ''}`}>
          <div
            className={`acc-btn${activeIndex === i ? ' active' : ''}`}
            onClick={() => toggle(i)}
          >
            {item.question}
            <div className="icon fa fa-plus"></div>
          </div>
          {activeIndex === i && (
            <div className="acc-content current">
              <div className="content">
                <div className="text">{item.answer}</div>
              </div>
            </div>
          )}
        </li>
      ))}
    </ul>
  );
}
